import { createSelector } from 'reselect';

const selectShipments = (state: any) => state.shipments;


export const selectShipmentsCurrentItem = createSelector([selectShipments], (shipments) => shipments.current);

export const selectShipmentsListItems = createSelector([selectShipments], (shipments) => shipments.list);

export const selectShipmentsItemById = (itemId: any) =>
    createSelector(selectShipmentsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectShipmentsQueryItems = createSelector([selectShipments], (shipments) => shipments.query);

export const selectShipmentsCreatedItem = createSelector([selectShipments], (shipments) => shipments.create);

export const selectShipmentsUpdatedItem = createSelector([selectShipments], (shipments) => shipments.update);

export const selectShipmentsReadItem = createSelector([selectShipments], (shipments) => shipments.read);

export const selectShipmentsDeletedItem = createSelector([selectShipments], (shipments) => shipments.delete);

export const selectShipmentsSearchedItems = createSelector([selectShipments], (shipments) => shipments.search);

export const selectShipmentsItemsCount = createSelector([selectShipments], (shipments) => shipments.count);

export const selectShipmentsItemsFilter = createSelector([selectShipments], (shipments) => shipments.filter);